import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
    Card,
    CardContent,
    Grid,
    IconButton,
    TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CreateIcon from "@mui/icons-material/Create";
import { withRouter } from "react-router";
import { validacionTagResources } from "../endpoints";
import DialogEditarCantidadValidacionTag from "./DialogEditarCantidadValidacionTag";

class TablaCantidadPorCodigoValidado extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tags_contados: null,
            tags_validados: null,
            porcentaje_validados: null,
            datos: [],
            datosFiltrados: [],
            tag: null,
            cantidad_validada: null,
            cantidad_inv: null,
            editar: false,
            cargando: false,
            selectedRow: null,
            searchText: "",
            codigo:null,
        };
    }

    refrescar = (estado, severity) => {
        this.setState({ editar: false });
        this.props.refrescar(estado, severity);
        this.consultarTagsValidados();
    };

    handleClose = () => {
        this.setState({ editar: false });
    };

    consultarTagsValidados = () => {
        let tipo = this.props.tipo;
        this.setState({ cargando: true });
        validacionTagResources
            .getValidacionCantidadPorCodigo(tipo)
            .then(async (response) => {
                if (response) {
                    return await response.json();
                }
            })
            .then((data) => {
                if (data.status_code === 200) {
                    const rows = data.consulta.map((row, index) => ({
                        ...row,
                        id: row.id ?? index,
                    }));
                    this.setState({
                        datos: rows,
                        datosFiltrados: rows,
                        cargando: false,
                    });
                } else if (data.status_code === 401) {
                    this.setState({
                        openSnack: true,
                        severity: data.severity,
                        message: data.message,
                    });
                } else {
                    throw new Error("Something went wrong ...");
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    verDetalleTag = (row) => {
        if (row) {
            this.props.history.push("/detalles_tag/" + row.tag);
        }
    };

    editarCantidadValidada = (row) => {
        this.setState({
            editar: true,
            cantidad_validada: row.cantidad_validada,
            tag: row.tag,
            codigo: row.codigo,
            cantidad_inv: row.cantidad_contada,
        });
    };

    obtenerTotales = () => {
        validacionTagResources
            .getTotales('cantidad_por_codigo')
            .then(async (response) => {
                if (response.ok) {
                    return await response.json();
                } else {
                    throw new Error("Something went wrong ...");
                }
            })
            .then((data) => {
                if (data.tags_contados == null || data.tags_contados === 0){
                    this.setState({
                        tags_contados: new Intl.NumberFormat("de-DE").format(
                            data.tag_contados
                        ),
                        tags_validados: new Intl.NumberFormat("de-DE").format(
                            data.tag_validados
                        ),
                        porcentaje_validados: 0});
                }
                else{
                    this.setState({
                        tags_contados: new Intl.NumberFormat("de-DE").format(
                            data.tag_contados
                        ),
                        tags_validados: new Intl.NumberFormat("de-DE").format(
                            data.tag_validados
                        ),
                        porcentaje_validados: (data.tag_validados/data.tag_contados * 100).toFixed(2),
                    });
                }

            })
            .catch((error) => {
                console.error(error);
            });
        this.consultarTagsValidados();
    };

    componentDidMount() {
        this.obtenerTotales();
    }

    handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        const filtrados = this.state.datos.filter((row) =>
            Object.values(row).some(
                (val) => val && val.toString().toLowerCase().includes(value)
            )
        );
        this.setState({ searchText: value, datosFiltrados: filtrados });
    };

    render() {
        const columns = [
            { field: "tag", headerName: "Tag",flex: 1, minWidth: 120,},
            { field: "codigo", headerName: "Código",flex: 1, minWidth: 120,},
            {
                field: "cantidad_contada",
                headerName: "Cantidad Inv.",
                flex: 1, minWidth: 120,
                valueFormatter: (params) =>
                    new Intl.NumberFormat("de-DE").format(params.value),
            },
            {
                field: "cantidad_validada",
                headerName: "Cantidad Val.",
                flex: 1, minWidth: 120,
                valueFormatter: (params) =>
                    new Intl.NumberFormat("de-DE").format(params.value),
            },
            {
                field: "diferencia",
                headerName: "Diferencia",
                flex: 1,
                minWidth: 120,
                valueGetter: (params) =>
                    (params.row.cantidad_contada ?? 0) - (params.row.cantidad_validada ?? 0),
                valueFormatter: (params) =>
                    new Intl.NumberFormat("de-DE").format(params.value),
            },
            { field: "validador", headerName: "Cod. Validador", flex: 1, minWidth: 120,},
            {
                field: "acciones",
                headerName: "Acciones",
                flex: 1, minWidth: 120,
                sortable: false,
                filterable: false,
                renderCell: (params) => (
                    <>
                        <IconButton
                            title="Ver tag"
                            onClick={() => this.verDetalleTag(params.row)}
                        >
                            <SearchIcon />
                        </IconButton>
                        <IconButton
                            title="Editar cantidad validada"
                            onClick={() => this.editarCantidadValidada(params.row)}
                        >
                            <CreateIcon />
                        </IconButton>
                    </>
                ),
            },
        ];

        return (
            <div>
                <Card style={{ background: "#dbe9fc" }}>
                    <CardContent>
                        <Grid container spacing={4} alignItems={"center"} justifyContent={"center"}>
                            <Grid item>
                                <b>Total Tags Inv.: </b>
                                {this.state.tags_contados}
                            </Grid>
                            <Grid item>
                                <b>Total tags Val.: </b>
                                {this.state.tags_validados}
                            </Grid>
                            <Grid item>
                                <b>Validación (%): </b>
                                {this.state.porcentaje_validados}
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <br />
                <TextField
                    placeholder="Buscar"
                    variant="outlined"
                    size="small"
                    value={this.state.searchText}
                    onChange={this.handleSearch}
                    style={{ marginBottom: 10 }}
                />
                <div style={{ height: 600, width: "100%" }}>
                    <DataGrid
                        disableColumnMenu
                        disableColumnResize={true}
                        rows={this.state.datosFiltrados}
                        columns={columns}
                        loading={this.state.cargando}
                        onRowClick={(params) =>
                            this.setState({ selectedRow: params.id })
                        }
                        getRowClassName={(params) =>
                            this.state.selectedRow === params.id ? "row-selected" : ""
                        }
                        pageSizeOptions={[10, 30, 50]}
                        getRowHeight={() => 'auto'}
                        initialState={{
                            pagination: {
                                paginationModel: {pageSize: 30, page: 0},
                            },
                        }}
                    />
                </div>
                {this.state.editar && (
                    <DialogEditarCantidadValidacionTag
                        refrescar={this.refrescar}
                        tag={this.state.tag}
                        tipo = 'cantidad_por_codigo'
                        cantidad_actual={this.state.cantidad_validada}
                        cantidad_inv={this.state.cantidad_inv}
                        handleClose={this.handleClose}
                        codigo={this.state.codigo}
                    />
                )}
            </div>
        );
    }
}

export default withRouter(TablaCantidadPorCodigoValidado);
